import type { SxProps, Theme } from '@mui/material';

export const maxHeightFlexSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
};

export const hideMuiInputAdornmentIconSx = {
  '& .MuiInput-root .MuiInputAdornment-root': {
    display: 'none',
  },
};
